import { useCallback, useEffect, useState } from "react";
import { ArrowClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import { unwrap, extractRows } from "../../lib/helpers";
import { KVTable, DynamicTable } from "../../components/DataViews";
import { Button } from "../../components/ui/button";
import { Skeleton } from "../../components/ui/skeleton";

export function SettingsTab({ businessId, projectId }) {
  const [settings, setSettings] = useState(null);
  const [abroad, setAbroad] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [s, a] = await Promise.all([
        api.get("/dashboard/projects/settings", {
          params: { wydely_business_id: businessId, wydely_project_id: projectId },
        }),
        api.get("/dashboard/abroad/project", {
          params: { wydely_business_id: businessId, wydely_project_id: projectId, enabled_only: true },
        }),
      ]);
      setSettings(unwrap(s.data));
      setAbroad(unwrap(a.data));
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [businessId, projectId]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading)
    return (
      <div className="space-y-3" data-testid="settings-loading">
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} className="h-24 w-full" />
        ))}
      </div>
    );

  const abroadRows = extractRows(abroad);

  return (
    <div className="space-y-6" data-testid="settings-tab">
      <div className="flex justify-end">
        <Button variant="outline" size="sm" onClick={load} data-testid="settings-refresh">
          <ArrowClockwise className="mr-2 h-4 w-4" /> Refresh
        </Button>
      </div>

      <section className="space-y-3">
        <h3 className="text-base font-display font-bold tracking-tight">Project settings & rates</h3>
        <KVTable data={settings} testId="settings-table" />
      </section>

      <section className="space-y-3">
        <h3 className="text-base font-display font-bold tracking-tight">
          Enabled abroad countries <span className="text-muted-foreground font-normal">({abroadRows.length})</span>
        </h3>
        <DynamicTable rows={abroadRows} testId="abroad-countries-table" empty="No abroad countries enabled. India (+91) is always allowed via normal project rates." />
      </section>
    </div>
  );
}
